export type { PillVariant } from './status-pill';
export { default } from './status-pill';
